import { TFunction } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { IntroDataProps, IntroNavProps } from './Intro.types';

export const NAVDATA = (t: TFunction): IntroNavProps[] => [
  {
    section: 'talent',
    img: getPublicPath('/images/stateSector/2023/talent-nav.jpg'),
    text: t('mandecar23.nav.talent')
  },
  {
    section: 'benefits',
    img: getPublicPath('/images/stateSector/2023/benefits-nav.jpg'),
    text: t('mandecar23.nav.benefits')
  },
  {
    section: 'companies',
    img: getPublicPath('/images/stateSector/2023/companies-nav.jpg'),
    text: t('mandecar23.nav.companies')
  },
  {
    section: 'gender',
    img: getPublicPath('/images/stateSector/2023/gender-nav.jpg'),
    text: t('mandecar23.nav.talent-management')
  }
];

export const INTRODATA = (
  t: TFunction,
  locale: string | undefined,
  manfreditesCount: number
): IntroDataProps[] => [
  {
    value: manfreditesCount.toLocaleString(locale),
    text: t('mandecar23.data.people')
  },
  {
    value: '+12.000',
    text: t('mandecar23.data.current')
  },
  {
    value: '40%',
    text: t('mandecar23.data.companies')
  },
  {
    value: '+500',
    text: t('mandecar23.data.time-to-hire')
  }
];
